import { createGlobalStyle } from "styled-components";

export const TabsGlobalStyle = createGlobalStyle`
.nav-underline .nav-link.active {
    border-bottom-color: var(--color-accent-dark) !important;
}
`;